import { ofType } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { catchErrorLogRet } from '../../../common/rest.operators';
import { PayloadAction } from '../../../store.model';
import { EvaluationService } from '../../core';
import { getModuleInjector } from '../../evaluation.metadata';
import { ActionType } from '../form.action';
import { draftPostTransformer } from '../transformer/draft-post.transformer';

import { Save, saveResult } from './save.action';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const save = (action: Observable<PayloadAction<ActionType, Save>>) =>
    action.pipe(
        ofType(ActionType.EVAL_FORM__SAVE),
        switchMap((act: PayloadAction<ActionType, Save>) => {
            const service =
                getModuleInjector().get<EvaluationService>(EvaluationService);

            const draft = draftPostTransformer(act.payload.formValue);
            let which: 'publish' | 'update' | 'create';
            let fn: Observable<any>;
            if (act.payload.publish === true) {
                which = 'publish';
                fn =
                    act.payload.formValue.responseId != null
                        ? service.updateResponse(
                              act.payload.formValue.responseId,
                              draft,
                          )
                        : service.publishDraft(draft);
            } else if (draft?.draftId != null) {
                which = 'update';
                fn = service.updateDraft(draft);
            } else {
                which = 'create';
                fn = service
                    .createDraft(draft)
                    .pipe(
                        switchMap((draftId) =>
                            service.retrieveDraft(
                                draftId,
                                act.payload.timeZoneOffset,
                            ),
                        ),
                    );
            }

            return fn.pipe(
                map((ret) => {
                    return saveResult(
                        {
                            ...act.payload,
                            draft: which === 'create' ? ret : null,
                        },
                        act.storePath,
                    );
                }),
                catchErrorLogRet(
                    of(saveResult({ ...act.payload }, act.storePath)),
                ),
            );
        }),
    );
